import request from "../../utils/request";
import server from "./config";

export default {
    /**
     * 患者端根据历史商品订单重新开具处方
     * @param {Object} data - { consultId: 新问诊ID, orderId: 原商品订单ID }
     * @returns {PrescriptionRespBody} 含 id(新处方ID)、doctorName、productList、totalPrice 等
     */
    repurchase: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/repurchase`,
            method: "post",
            data
        });
    },
    /**
     * 根据处方查询关联的有效服务包（复购前置判断）
     * @param {Object} data - { prescriptionId: 处方ID }
     * @returns {Array} 服务包列表；普通处方订单(无服务包)返回空数组
     *   每项含 serviceAggId(服务包主键, 传给 repurchase 的 serviceAggId)、
     *   serviceAggName、price、tenantId、serviceAggDescription、sessionName、
     *   medicineName/medicineSpecification(关联药品)、servicePackageContent 等
     */
    getServiceAggListByPrescriptionId: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/getServiceAggListByPrescriptionId`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/prescription.js